import React from "react";
import IFrameWrapper from "./IFrameWrapper";
import { EventData } from "../types/chatbot.types";

interface ReferralFormContainerProps {
	iframeActive: boolean;
	selectedForm: EventData | null;
	onClose: () => void;
}

const ReferralFormContainer: React.FC<ReferralFormContainerProps> = ({
	iframeActive,
	selectedForm,
	onClose,
}) => {
	return (
		<div className={`iframe-container ${iframeActive ? "open" : ""}`}>
			{selectedForm !== null && (
				<IFrameWrapper
					onMessage={(messageType) => {
						if (messageType === "Submitted") {
							onClose();
						}
					}}
					onClose={onClose}
					title={`Referral Form: ${selectedForm.formId}`}
					headers={
						selectedForm !== null
							? [
									[
										"Xan-Authenticate",
										`${selectedForm.username}; ${selectedForm.TOTP}`,
									],
							  ]
							: []
					}
					formData={
						selectedForm !== null
							? {
									formId: selectedForm.formId,
									answers: selectedForm.answers || {},
									opt: selectedForm.opt || 0,
							  }
							: null
					}
				/>
			)}
		</div>
	);
};

export default ReferralFormContainer;
